import { Box, Theme, useTheme } from '@mui/material';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import { ReactComponent as OtherConfigurationIcon } from '../../assets/icons/Configuration-50.svg';
import { ReactComponent as MetricIcon } from '../../assets/icons/Metrics.svg';
import PanelOtherConfiguration from '../../components/configuration/other_configuration/PanelOtherConfiguration';

const ConfigurationOtherConfiguration = () => {
  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  return (
    <Box>
      <ConfigurationWrapper
        title="Other Configuration"
        icon={<OtherConfigurationIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/metrics',
          label: 'Metrics',
          icon: <MetricIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
        next={null}
      >
        <PanelOtherConfiguration />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationOtherConfiguration;
